import { render } from "./RolesModal.vue?vue&type=template&id=1bff3296&ts=true"
import script from "./RolesModal.vue?vue&type=script&lang=ts"
export * from "./RolesModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__